import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

const double = 2;
const styles = theme => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing.unit * double
  },

  link: {
    color: '#1A65FF',
  },
});

const Thankyou = (props) => {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <div className={classes.item}>
        <Typography color="primary" variant="display2">
          ご利用ありがとうございました
        </Typography>
      </div>
      <div className={classes.item}>
        <Typography color="inherit" variant="body1">私たちの製品を選んでいただきありがとうございました。</Typography>
        <Typography color="inherit" variant="body1">気が向いたら、またいつでも戻ってきてください。</Typography>
        <Typography color="inherit" variant="body1">私たちは明日もここにいます。</Typography>
      </div>
      <div className={classes.item}>
        <a className={classes.link} href="https://keymanletter.com/">Keyman Letter公式サイト</a>
      </div>
    </div>
  );
}

Thankyou.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Thankyou);



// WEBPACK FOOTER //
// ./src/components/Thankyou/Thankyou.jsx